import React from 'react';
import MUIDataTable from 'mui-datatables';

export let TableContainer = ({options, columns, data, intl}) => {


  return (
    <MUIDataTable
      data={data}
      columns={columns}
      options={{
        ...options,
        //textLabels: getTranslatedTableTextLabels(intl),
        //customSort: options && options.customSort ? options.customSort : customSortWithColumns,
      }}
    />
  );

};